import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ButtonIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { SiteData } from "../Data/SiteData";
import { AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { UpdateStyleFunction } from "../Stylebuilder";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import RenderButton from "vagaro-website-rendering/src/components/ComponentRenders/RenderButton";
import ApplyToGlobalButton from "../Menus/ApplyToGlobalButton";





export default class Button extends WBComponent {




    constructor(){
        super();

        this.typename = wBComponentTypeNames.button;
        this.displayName = "Button";
        this.dropList = defaultDropList;
        this.editList = ["buttonType","link","linkOpenType",...CreateAttributeList(true,true,true,true,false)];
        this.primaryEditAttributes = ["buttonType","link","linkOpenType"];
        this.contentEditable = true;
        this.icon = <ButtonIcon/>
        this.defaultGridSize = {width:200,height:50};

    }

    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean | undefined; siteData: SiteData;  }): JSX.Element {
        const content =  super.RenderMenu({editList,primaryList,layoutNode,screenSize,updateFunc,saveFunc,showScreenSize,siteData});

        if(!layoutNode)
            return content;




        const getCollection = ()=>{
            let collection = siteData.siteStyling.buttonPrimary;
            const newBtnType = getNodeComponentAttributeValue(layoutNode,"buttonType","primary");
            switch(newBtnType){
                case "primary":

                    collection = siteData.siteStyling.buttonPrimary;
                    break;
                case "secondary":
                    collection = siteData.siteStyling.buttonSecondary;
                    break;
                case "tertiary":
                    collection = siteData.siteStyling.buttonTertiary;
                    break;
                default:
                    break;
            }
            return collection;
        }

        return(
            <>
            {content}

            <br></br>
            {screenSize===ScreenSize.Desktop&&


            <ApplyToGlobalButton siteData={siteData} layoutNode={layoutNode} getCollectionFunc={getCollection} />}
            </>
        )

    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [

            new AttributeDefinition("buttonType","Button Type","",AttributeInputType.SelectField,
            [{label:"Primary",value:"primary"},{label:"Secondary",value:"secondary"},{label:"Tertiary",value:"tertiary"}]),

            new AttributeDefinition("link","Button Link","",AttributeInputType.LinkField),
            new AttributeDefinition("linkOpenType","Link Behavior","",AttributeInputType.Ignore,
            [{label:"Same Window",value:""},{label:"New Tab",value:"_blank"}]),
        ];
    }


    RenderLayout({screenSize,component,children,userContext,isEditor}:WBRenderProps)
     {

        return <RenderButton screenSize={screenSize} component={component} isEditor={isEditor} userContext={userContext} children={undefined}/>

    }

}